/*
 * @Author: your name
 * @Date: 2021-05-14 16:06:38
 * @LastEditTime: 2022-02-21 15:05:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-check/check/_api/index.js
 */

import { apiService } from '@/frameworks/http/request'
import store from '@/frameworks/store/index'
// let prefix = 'NQCS/'
let prefix = 'NQCS/DoAction?act='
let HospitalCode = store.state.user.HospitalCode
// 质控检查任务
export function GetZKJCList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZKJCList`,
    method: 'post',
    data: params
  })
}

export function GetKfxdmList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetKfxdmList`,
    method: 'post',
    data: params
  })
}

export function GetZKJCJGList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZKJCJGList`,
    method: 'post',
    data: params
  })
}

export function GetZYZKJCList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZYZKJCList`,
    method: 'post',
    data: params
  })
}

export function GetMyZYZKJCList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetMyZYZKJCList`,
    method: 'post',
    data: params
  })
}

// 获取质控组成员接口
export function GetZkzMemberInfo(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZkzMemberInfo`,
    method: 'post',
    data: params
  })
}

// 获取质控级别接口
export function GetCKLevelByUserId(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetCKLevelByUserId`,
    method: 'post',
    data: params
  })
}

// 获取人员信息接口
export function GetUserInfo(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetUserInfo`,
    method: 'post',
    data: params
  })
}

// 获取督查部门
export function GetCheckDepartInfoByZkjb(params) {
  // params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetCheckDepartInfoByZkjb`,
    method: 'post',
    data: params
  })
}
// 获取受检科室
export function GetZZjgByZkjbAndUser(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZZjgByZkjbAndUser`,
    method: 'post',
    data: params
  })
}
// 获取检查表单
export function GetJHJCBDList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetJHJCBDList`,
    method: 'post',
    data: params
  })
}

// 导出
export function Download(param) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `NQCS/Download?act=ExportZKJH`,
    method: 'post',
    responseType: 'blob',
    data: param,
    timeout: 15 * 60 * 1000
  })
}

export function GetOutPatientInfo(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetOutPatientInfo`,
    method: 'post',
    data: params
  })
}

// 获取质控检查详情
export function GetZKJCInfo(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZKJCInfo`,
    method: 'post',
    data: params
  })
}

// 获取质控检查详情
export function CalcZKJCData(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}CalcZKJCData`,
    method: 'post',
    data: params
  })
}

// 删除检查
export function DeleteZKJC(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}DeleteZKJC`,
    method: 'post',
    data: params
  })
}

// 撤回检查
export function CancleZKJC(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}CancleZKJC`,
    method: 'post',
    data: params
  })
}
